import React from "react";
import { useCallback } from "react";
import SignIn from "../Registration/SignIn/SignIn";
import SignUp from "../Registration/SignUp/SignUp";
import NavigatePanel from "./CenterNavbar/NavigationPanelMobile/NavigatePanel";
import { useSelector, useDispatch } from "react-redux";
import { togRegModalToFalse } from "../../REDUX/RegistrationModalToggle/toggleModal";
import { statesInNigeria } from "../Products/ProduArrs";
import NavDropDownPop from "./CenterNavbar/NavDropDownPop";
import Spinner from "../Components/Spinner";

const NavPopUp = () => {
  const { showStatePopUp } = useSelector((state) => state.DropDownNav);

  const { LoginStatus, signUpStatus, NavigatePanelModal } = useSelector(
    (state) => state.toggleReg
  );

  const dispatch = useDispatch();

  const togRegModalToFalseFunction = useCallback((event) => {
    // console.log(event.currentTarget);
    if (event.target === event.currentTarget) {
      console.log("Parent element clicked");
      dispatch(togRegModalToFalse());
    }
    // dispatch(togRegModalToFalse());
  }, []);

  /* disable scrrolbar if Registration Modal is true start  */
  // if (signUpStatus || LoginStatus) {
  //   window.scrollTo(0, 0);
  //   document.body.style.overflow = "hidden";
  // } else if (!LoginStatus || !signUpStatus) {
  //   document.body.style.overflow = "scroll";
  // }
  /* disable scrrolbar if Registration Modal is true end  */

  return (
    <>
      <Spinner />

      <div className="relative  ">
        {(signUpStatus || LoginStatus) && (
          <div
            className={`
            fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[999]`}
          >
            <div
              onClick={(e) => togRegModalToFalseFunction(e)}
              className="absolute inset-0 cursor-pointer showRegistModal"
            ></div>
            <div
              className="z-50"
              onClick={(e) => togRegModalToFalseFunction(e)}
            >
              {signUpStatus && <SignUp />}
              {LoginStatus && <SignIn />}
            </div>
          </div>
        )}

        {/* {NavigatePanelModal && ( */}
        <NavigatePanel NavigatePanelModal={NavigatePanelModal} />
        {/* )} */}
      </div>

      {/* The serach bar dropdoen box ehich show the list of state  */}

      <div className=" top-28 right-60 md:right-96 fixed z-[999]">
        {showStatePopUp ? <NavDropDownPop areas={statesInNigeria} /> : null}
      </div>
    </>
  );
};

export default NavPopUp;
